import type { ReactNode } from 'react';
import svgPaths from '../../../assets/imports/PgrmLandingPageDeslogada/svg-huqtkssm9g';
import { useInView } from '../../../hooks/useInView';
import styles from './Manuais.module.scss';

interface ManualData {
  readonly render: () => ReactNode;
  readonly title: string;
  readonly description: string;
  readonly href: string;
  readonly external?: boolean;
}

const BookIcon = () => (
  <div className={styles.iconInnerBook}>
    <svg
      className={styles.iconSvg}
      fill='none'
      height='32'
      viewBox='0 0 28 32'
      width='28'
    >
      <g clipPath='url(#clip-book)'>
        <path d={svgPaths.pabf9580} fill='#1351B4' />
      </g>
      <defs>
        <clipPath id='clip-book'>
          <rect fill='white' height='32' width='28' />
        </clipPath>
      </defs>
    </svg>
  </div>
);

const CommentsIcon = () => (
  <div className={styles.iconInnerComments}>
    <svg
      className={styles.iconSvg}
      fill='none'
      height='44'
      viewBox='0 0 49 44'
      width='49'
    >
      <path d={svgPaths.p1004b300} fill='#1351B4' />
    </svg>
  </div>
);

const DirectionsIcon = () => (
  <div className={styles.iconInnerDir}>
    <svg
      className={styles.iconSvg}
      fill='none'
      height='34'
      viewBox='0 0 34 34'
      width='34'
    >
      <g clipPath='url(#clip-dir)'>
        <path d={svgPaths.pa0cb180} fill='#1351B4' />
      </g>
      <defs>
        <clipPath id='clip-dir'>
          <rect fill='white' height='34' width='34' />
        </clipPath>
      </defs>
    </svg>
  </div>
);

const MANUALS: ManualData[] = [
  {
    render: BookIcon,
    title: 'Passo a passo PGRM',
    description:
      'Saiba como navegar na plataforma por meio do tutorial da PGRM.',
    href: '/demonstra/html/',
    external: true,
  },
  {
    render: CommentsIcon,
    title: 'Perguntas Frequentes',
    description:
      'Esclareça suas dúvidas sobre os procedimentos de arrecadação na PGRM.',
    href: 'https://www.gov.br/anm/pt-br/acesso-a-informacao/perguntas-frequentes',
    external: true,
  },
  {
    render: DirectionsIcon,
    title: 'Guia Fácil DIEF-CFEM',
    description:
      'Entenda as regras, os prazos e como apresentar sua declaração mensal.',
    href: 'https://www.gov.br/anm/pt-br/centrais-de-conteudos/guia-facil/guia-facil-dief-cfem',
    external: true,
  },
];

function ManualCard({
  manual,
  delay,
}: Readonly<{ manual: ManualData; delay: number }>) {
  const [ref, inView] = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${inView ? 'inView' : ''}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className={styles.cardTop}>
        <div className={styles.iconBox}>
          <div className={styles.iconClip}>{manual.render()}</div>
        </div>
        <div className={styles.texts}>
          <p className={styles.cardTitle}>{manual.title}</p>
          <p className={styles.cardDesc}>{manual.description}</p>
        </div>
      </div>
      <div className={styles.cardFooter}>
        <a
          className={styles.button}
          href={manual.href}
          target={manual.external ? '_blank' : '_self'}
          rel={manual.external ? 'noopener noreferrer' : undefined}
        >
          <span>Acessar Manual</span>
          <i className='fas fa-arrow-right' aria-hidden='true' />
        </a>
      </div>
    </div>
  );
}

export function Manuais() {
  return (
    <div id='manuais' className={styles.section} data-name='manuais'>
      <div className={styles.heading}>
        <div className={styles.titleWrap}>
          <p className={styles.title}>Manuais</p>
          <div className={styles.underline} />
        </div>
        <p className={styles.subtitle}>
          Documentação técnica de apoio para o preenchimento de declarações e
          utilização dos sistemas da Plataforma de Gestão de Royalties de
          Mineração.
        </p>
      </div>
      <div className={styles.cards}>
        {MANUALS.map((m, i) => (
          <ManualCard key={m.title} manual={m} delay={i * 0.12} />
        ))}
      </div>
    </div>
  );
}
